import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants, findEntityById } from "@qgiv/core-js";
import { useFormikContext } from "formik";
import { selectIsCms } from "../../../redux/slices/configSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectAllCategories } from "../../../redux/slices/categoriesSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import Waiver from "./Waiver";

const defaultWaiverText = `Curabitur blandit tempus porttitor. Aenean lacinia
bibendum nulla sed consectetur. Nulla vitae elit libero, a pharetra augue. 
Etiam porta sem malesuada magna mollis euismod. Maecenas faucibus mollis 
interdum. Donec ullamcorper nulla non metus auctor fringilla. Donec sed 
odio dui. Sed posuere consectetur est at lobortis. Praesent commodo cursus 
magna, vel scelerisque nisl consectetur et. Morbi leo risus, porta ac 
consectetur ac, vestibulum at eros. Vivamus sagittis lacus vel augue 
laoreet rutrum faucibus dolor auctor. Sed posuere consectetur est at 
lobortis. Fusce dapibus, tellus ac cursus commodo, tortor mauris 
condimentum nibh, ut fermentum massa justo sit amet risus.
Nulla vitae elit libero, a pharetra augue. Praesent commodo cursus magna, vel 
scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet 
rutrum faucibus dolor auctor. Morbi leo risus, porta ac consectetur ac, 
vestibulum at eros. Maecenas faucibus mollis interdum. Sed posuere 
consectetur est at lobortis. Integer posuere erat a ante venenatis dapibus 
posuere velit aliquet. Nulla vitae elit libero, a pharetra augue. 
Vestibulum id ligula porta felis euismod semper.`;

const ConnectedWaiver = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const { values } = useFormikContext();
    const { Category } = values;

    const isCms = useSelector(selectIsCms);
    const { onlineWaiver } = useSelector(selectAllP2pSettings);
    const categories = useSelector(selectAllCategories);

    const currentCategory =
        Category && categories.find(findEntityById(Number(Category[0])));

    const waiverIsEnabled = Category.length
        ? currentCategory.enableWaiver
        : false;

    // Determines when enabled by category
    const isEnabledByCategory = isCms ? true : waiverIsEnabled;

    // Sets either default or custom category waiver content
    const waiverText =
        // eslint-disable-next-line no-nested-ternary
        isEnabledByCategory && currentCategory && currentCategory.waiver
            ? currentCategory.waiver
            : // eslint-disable-next-line no-nested-ternary
              onlineWaiver.length > 0
              ? onlineWaiver
              : isCms
                ? defaultWaiverText
                : "";

    const isVisible = isCms
        ? true
        : typeof waiverText === "string" &&
          waiverText.length > 0 &&
          isEnabledByCategory;

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_DETAILS_STEP,
            state,
        ),
    );

    const {
        options: {
            subsectionHeading = "Waiver",
            additionalText,
            waiverCheckbox = "I agree and accept the following terms and conditions:",
            showMoreLink = "Show more",
            showLessLink = "Show less",
        },
    } = control;

    const waiverProps = {
        waiverText,
        isVisible,
        waiverCheckbox,
        showMoreLink,
        showLessLink,
        subsectionHeading,
        additionalText,
    };

    return <Waiver {...waiverProps} />;
};

ConnectedWaiver.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedWaiver;
